import { createEntityAdapter } from '@ngrx/entity';
import { CurrentUserState } from './states/current-user.state';

export const entityAdapter = createEntityAdapter<CurrentUserState>();
